import { displayDate } from "../Backend";

const formatter = new Intl.RelativeTimeFormat(undefined, {
  numeric: "auto",
});

const GENERIC_DIVISIONS: { amount: number; name: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, name: "seconds" },
  { amount: 60, name: "minutes" },
  { amount: 24, name: "hours" },
  { amount: 7, name: "days" },
  { amount: 4.34524, name: "weeks" },
  { amount: 12, name: "months" },
  { amount: Number.POSITIVE_INFINITY, name: "years" },
];
const NO_SECONDS_DIVISIONS: { amount: number; name: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, name: "minutes" },
  { amount: 24, name: "hours" },
  { amount: 7, name: "days" },
  { amount: 4.34524, name: "weeks" },
  { amount: 12, name: "months" },
  { amount: Number.POSITIVE_INFINITY, name: "years" },
];

export function formatTimeAgo(date: Date) {
  const durationSeconds = (date.getTime() - Date.now()) / 1000;

  let durationRemaining = durationSeconds;
  for (const division of GENERIC_DIVISIONS) {
    if (Math.abs(durationRemaining) < division.amount) {
      return formatter.format(Math.round(durationRemaining), division.name);
    }
    durationRemaining /= division.amount;
  }
}

const ONE_WEEK_MINUTES = 60 * 24 * 7;
export function formatTimeAgoNoSeconds(date: Date) {
  const durationMinutes = (date.getTime() - Date.now()) / 1000 / 60;

  const durationAbs = Math.abs(durationMinutes);
  if (durationAbs > ONE_WEEK_MINUTES) {
    return displayDate(date);
  }

  let durationRemaining = durationMinutes;
  for (const division of NO_SECONDS_DIVISIONS) {
    if (Math.abs(durationRemaining) < division.amount) {
      return formatter.format(Math.round(durationRemaining), division.name);
    }
    durationRemaining /= division.amount;
  }
}
